import { collapseGroups } from '../../store/grouping/actions';
import { ACTION_DECREASE, ACTION_INCREASE, ACTION_SET, GroupBy } from '../../store/constants';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../store/notifications/actions';
import { invalidateSelectionListAggregations } from '../../shop/selectionlists/useSelectionListAggregations';
import { invalidateSelectionListSummary } from './useSelectionListSummary';
import { invalidateSelectionListGroupedItems } from './useSelectionListGroupedItems';
import { invalidateSelectionListProducts } from '../../shop/selectionlists/api/useSelectionListProducts';
import { http } from '../axios';
import { shopPrefix } from '../../config';
import { failSelectionlists } from '../../store/orderlist/actions';
import { BulkActionResponse } from '../../store/api';

type Group = { key: GroupBy; id: string };

const changeAmountProduct = (
    listId: string,
    group: Group,
    amount: number,
    command: typeof ACTION_SET | typeof ACTION_INCREASE | typeof ACTION_DECREASE
) => {
    const pathParams = {
        listId,
        bundleId: group.id
    };

    const body = { targetAmount: amount };

    switch (command) {
        case ACTION_DECREASE:
            return http.put<BulkActionResponse>(
                `${shopPrefix}/v2/selectionlists/:listId/bulk/quantity/bundle/:bundleId/decrease`,
                body,
                {
                    pathParams
                }
            );
        case ACTION_INCREASE:
            return http.put<BulkActionResponse>(
                `${shopPrefix}/v2/selectionlists/:listId/bulk/quantity/bundle/:bundleId/increase`,
                body,
                {
                    pathParams
                }
            );
        case ACTION_SET:
            return http.put<BulkActionResponse>(
                `${shopPrefix}/v2/selectionlists/:listId/bulk/quantity/bundle/:bundleId/setAmount`,
                body,
                {
                    pathParams
                }
            );
    }
};

export const useChangeAmountGroupedItemInList = ({ listId }: { listId: string }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return {
        changeAmountGroupedItem: async (
            group: Group,
            amount: number,
            command: typeof ACTION_SET | typeof ACTION_INCREASE | typeof ACTION_DECREASE
        ) => {
            try {
                const response = await changeAmountProduct(listId, group, amount, command);

                dispatch(collapseGroups());
                dispatch(showNotification(t('notifications.copyAmountChangeListBulk.message')));
                invalidateSelectionListAggregations(listId).then();
                invalidateSelectionListSummary(listId).then();
                invalidateSelectionListGroupedItems(listId).then();
                invalidateSelectionListProducts(listId).then();

                return response.data;
            } catch (error) {
                dispatch(failSelectionlists(error));
                invalidateSelectionListGroupedItems(listId).then();

                throw error;
            }
        }
    };
};
